import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { withStyles } from "@material-ui/core/styles";
import ProgressiveImage from "./ProgressiveImage";

import { isMobile } from "../../userAgentDetect";

const styles = theme => ({
  container: {
    position: "relative"
  },
  heroImg: {
    width: "100%"
  },
  taglineContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "60%",
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto"
  },
  tagline: {
    maxWidth: 576,
    fontWeight: 300,
    textAlign: "center",
    lineHeight: 1.4,
    color: "#ffffff"
  },
  [theme.breakpoints.down("sm")]: {
    taglineContainer: {
      width: "90%"
    },
    tagline: {
      fontSize: "1.5rem"
    }
  }
});

class HeroImage extends Component {
  render() {
    const {
      classes,
      alt,
      imgSmall,
      imgLarge,
      backgroundColor,
      className,
      tagline,
      renderTagline,
      paddingBottom = isMobile ? "260px" : "41.67%"
    } = this.props;
    return (
      <div className={classNames(classes.container, className)}>
        <ProgressiveImage
          className={classes.heroImg}
          alt={alt}
          imgSmall={imgSmall}
          imgLarge={imgLarge}
          backgroundColor={backgroundColor}
          paddingBottom={paddingBottom}
        />
        <div className="mask" />
        <div className={classes.taglineContainer}>
          {renderTagline ? (
            renderTagline()
          ) : (
            <h3 className={classes.tagline}>{tagline}</h3>
          )}
        </div>
      </div>
    );
  }
}
HeroImage.propTypes = {
  classes: PropTypes.object.isRequired,
  tagline: PropTypes.string,
  renderTagline: PropTypes.func,
  imgSmall: PropTypes.string,
  imgLarge: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  className: PropTypes.string
};

export default withStyles(styles)(HeroImage);



// WEBPACK FOOTER //
// ./src/components/Image/HeroImage.js